var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    // Align content
    'flex',
    'justify-between',
    'items-center',
    'text-base',
    // Padding
    'px-4',
    'sm:px-6',
    'py-4',
    'sm:py-6' ]},[_c('div',{class:['mr-4', _vm.disabled ? 'text-dark-text-400 dark:text-light-text-400' : '']},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.subText))])]),_vm._v(" "),(_vm.buttonText)?[(_vm.isPhone)?_c('OzContainedButton',{key:"icon-button",staticClass:"flex-shrink-0",attrs:{"disabled":_vm.disabled,"aria-label":_vm.buttonText},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('OzIcon',{attrs:{"name":"continue_large","size":16}})]},proxy:true}],null,false,4250753249)}):_c('OzContainedButton',{key:"text-button",attrs:{"disabled":_vm.disabled,"text":_vm.buttonText},on:{"click":function($event){return _vm.$emit('click')}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }